export const ERROR_CODE = {
    PAYMENT_INSTRUCTION_CREATION_FAILED: "KT-FR-3910",
    INVALID_NAME: "KT-FR-4113",
    SELF_READINGS_ALREADY_PROVIDED_READINGS: "KT-FR-4518",
    SELF_READINGS_INCONSISTENT_VALUES: "KT-FR-4515",
    SELF_READINGS_UNKNOWN_ERROR: "KT-FR-4517",
    WEB_SERVICE_REQUEST_ALREADY_EXISTS: "KT-FR-4516",
    WEB_SERVICE_REQUESTED_DATE_NOT_ALLOWED: "KT-FR-4514",
    WEB_SERVICE_TECHNICAL_ERROR: "KT-FR-4513",
    DIFFERENT_ADDRESS_FORM_SUPPLY_POINTS: "KT-FR-4527",
    AUTH_HEADER_NOT_PROVIDED: "KT-CT-1112",
    INVALIDATE_PRE_SIGNED_TOKEN_UNAUTHORIZED: "KT-CT-1129",
    OBTAIN_KRAKEN_TOKEN_INVALID_PRE_SIGNED_TOKEN: "KT-CT-1142",
    ACCOUNT_NOT_FOUND: "KT-CT-5418",
    INVALID_IBAN: "KT-CT-3948",
    AFFILIATE_SESSION_INVALID_SUBDOMAIN: "KT-CT-7713",
    REFRESH_TOKEN_EXPIRED: "KT-CT-1120",
    EXPIRED_AFFILIATE_LINK: "KT-CT-7718",
    NOT_IO_ELLIGIBLE: "NOT_IO_ELLIGIBLE",
    NOT_OCTOTEMPO_ELLIGIBLE: "NOT_OCTOTEMPO_ELLIGIBLE",
    TOKEN_EXPIRED: "KT-CT-1124",
    UNAUTHORIZED: "KT-CT-1111",
    JOIN_SUPPLIER_ALREADY_IN_PROGRESS: "KT-CT-10315", // KT-CT-10315 = INVALID_INPUT_DATA but it is only use for an error of join supplier, to change when we will have access to errorCodes in extensions
    JOIN_SUPPLIER_NOT_IN_PROGRESS: "JOIN_SUPPLIER_NOT_IN_PROGRESS",
    NOT_FOUND: "NOT_FOUND",
    ACCEPT_TERMS_AND_CONDITIONS_FAILED: "ACCEPT_TERMS_AND_CONDITIONS_FAILED",
    ACCOUNT_ALREADY_EXISTS: "ACCOUNT_ALREADY_EXISTS",
    CREATE_ACCOUNT_FAILED: "CREATE_ACCOUNT_FAILED",
    ENROLLMENT_FAILED: "ENROLLMENT_FAILED",
    SELECT_PRODUCTS_FAILED: "SELECT_PRODUCTS_FAILED",
    QUOTE_FAILED: "QUOTE_FAILED",
    UNKNOWN_ERROR: "UNKNOWN_ERROR",
    UNKNOWN_METER_POINT: "UNKNOWN_METER_POINT",
    LEAVE_SUPPLIER_FAILED: "LEAVE_SUPPLIER_FAILED",
    // TODO remove below error code when backend actually provides REFRESH_TOKEN_EXPIRED in its related errors
    REFRESH_TOKEN_EXPIRED_MESSAGE: "The refresh token has expired.",
} as const

export const PARSE_ERROR_CODE = {
    AFFILIATE_LINK_ERROR: "AFFILIATE_LINK_ERROR",
    AFFILIATE_SESSION_ERROR: "AFFILIATE_SESSION_ERROR",
} as const
